import cx from 'classnames';
import React from 'react';
import styles from './video.module.scss';
export var VideoSize;
(function (VideoSize) {
    VideoSize["small"] = "small";
    VideoSize["mediumSmall"] = "mediumSmall";
    VideoSize["medium"] = "medium";
    VideoSize["large"] = "large";
    VideoSize["auto"] = "auto";
})(VideoSize || (VideoSize = {}));
export const Video = ({ title, source, isAutoplay, size, className, hideControls, ...restProps }) => {
    const getVideoSource = () => `${source}?videoFoam=true
            &&copyLinkAndThumbnailEnabled=false
            &&autoPlay=${isAutoplay}&fitStrategy=fill${hideControls ? '&chromeless=true' : ''}`;
    return (React.createElement("div", { className: cx(className, styles.videoRatio, styles[size]), ...restProps },
        React.createElement("iframe", { "data-testid": "iframe-video-component", src: getVideoSource(), title: title, scrolling: "no", allowFullScreen: true })));
};
//# sourceMappingURL=video.js.map